konnyScript(function ($) {

  var winHref = window.location.href;
  if (winHref.indexOf('utm_') != -1) {
    var afterHref = winHref.split('26winter-present-campaign')

    if ($('#knBoxBtn01 a').length) {
      var conHref01 = $('#knBoxBtn01 a').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtn01 a').prop('href', conHref01);
    } else {
      var conHref01 = $('#knBoxBtn01').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtn01').prop('href', conHref01);
    }

    if ($('#knBoxBtn02 a').length) {
      var conHref02 = $('#knBoxBtn02 a').prop('href');
      conHref02 = conHref02 + afterHref[1];
      $('#knBoxBtn02 a').prop('href', conHref02);
    } else {
      var conHref02 = $('#knBoxBtn02').prop('href');
      conHref02 = conHref02 + afterHref[1];
      $('#knBoxBtn02').prop('href', conHref02);
    }

    if ($('#knBoxBtn03 a').length) {
      var conHref01 = $('#knBoxBtn03 a').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtn03 a').prop('href', conHref01);
    } else {
      var conHref01 = $('#knBoxBtn03').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtn03').prop('href', conHref01);
    }

    if ($('#knBoxBtn04 a').length) {
      var conHref02 = $('#knBoxBtn04 a').prop('href');
      conHref02 = conHref02 + afterHref[1];
      $('#knBoxBtn04 a').prop('href', conHref02);
    } else {
      var conHref02 = $('#knBoxBtn04').prop('href');
      conHref02 = conHref02 + afterHref[1];
      $('#knBoxBtn04').prop('href', conHref02);
    }

    if ($('#knBoxBtn05 a').length) {
      var conHref01 = $('#knBoxBtn05 a').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtn05 a').prop('href', conHref01);
    } else {
      var conHref01 = $('#knBoxBtn05').prop('href');
      conHref01 = conHref01 + afterHref[1];
      $('#knBoxBtnknBoxBtn0501').prop('href', conHref01);
    }
  }

  $('[id^=\'knbox_swiper_slide\']').each(function (index) {
    index = index + 1;
    var slidePage1 = '#knbox_swiper_slide' + index + ' .swiper-pagination';
    var slidePage2 = '#knbox_swiper_slide' + index + ' .swiper-progress';
    var slideScr = '#knbox_swiper_slide' + index + ' .swiper-scrollbar';
    var slideNext = '#knbox_swiper_slide' + index + ' .swiper-button-next';
    var slidePrev = '#knbox_swiper_slide' + index + ' .swiper-button-prev';
    var babySlide = new Swiper(this, {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      centeredSlides: true,
      observer: true,
      observeParents: true,
      loop: true,
      pagination: true,
      pagination: {
        el: slidePage2,
        type: 'progressbar'
      },
      scrollbar: {
        el: slideScr,
        hide: true,
      },
      navigation: {
        nextEl: slideNext,
        prevEl: slidePrev,
      },
    });
  });


  /* --------------------------------------------------------
   * [fix 버튼 로직 개선] 2026.03.27
   * 기존: 하나의 버튼에 fix 클래스를 toggle하여
   *      본문 버튼과 고정 버튼 역할을 겸함
   *      → position 변경 시 문서 흐름 영향으로 깜빡임 발생
   *      → 이미지 로드 전 document 높이 계산 시 타이밍 이슈
   * 변경: 고정 버튼(#knBoxBtn01)을 별도 요소로 분리,
   *      본문 버튼(#knBoxBtn02) 기준으로 show/hide 제어
   * -------------------------------------------------------- */

  /* [기존 코드 - 초기 로드 시 fix 판단] 
  if ($('#knBoxBtn01').length) {
    var fixBtOffset = $('#knBoxBtn01').offset();

    var vHeight = $(window).height();

    var fixPar1 = parseInt(fixBtOffset.top / vHeight);
    var fixPar2 = fixBtOffset.top % vHeight;

    var footerOffset = $('footer').offset();
    var fixPar3 = footerOffset.top - vHeight;

    if (fixPar1 == 0) {
      if ($(document).scrollTop() > fixPar3) {
        $('#knBoxBtn01').removeClass('fix');
      } else if ($(document).scrollTop() > 0) {
        $('#knBoxBtn01').addClass('fix');
      } else {
        $('#knBoxBtn01').removeClass('fix');
      }
    } else {
      if ($(document).scrollTop() > fixPar3) {
        $('#knBoxBtn01').removeClass('fix');
      } else if ($(document).scrollTop() > vHeight * fixPar1) {
        $('#knBoxBtn01').addClass('fix');
      } else {
        $('#knBoxBtn01').removeClass('fix');
      }
    }
  }

  $(window).scroll(function () {
    if ($('#knBoxBtn01').length) {
      if (fixPar1 == 0) {
        if ($(document).scrollTop() > fixPar3) {
          $('#knBoxBtn01').removeClass('fix');
        } else if ($(document).scrollTop() > 0) {
          $('#knBoxBtn01').addClass('fix');
        } else {
          $('#knBoxBtn01').removeClass('fix');
        }
      } else {
        if ($(document).scrollTop() > fixPar3) {
          $('#knBoxBtn01').removeClass('fix');
        } else if ($(document).scrollTop() > vHeight * fixPar1) {
          $('#knBoxBtn01').addClass('fix');
        } else {
          $('#knBoxBtn01').removeClass('fix');
        }
      }
    }
  });
  [기존 코드 끝] */

  if ($('#knBoxBtn01').length && $('#knBoxBtn02').length) {
    var anchor = $('#knBoxBtn02'); // 인트로 본문 버튼

    function updateFixedBtn() {
      var scrollTop = $(document).scrollTop();
      var vHeight = $(window).height();
      var headerHeight = $('header').outerHeight() || 0;
      var anchorBottom = anchor.offset().top + anchor.outerHeight();
      var footerTop = $('footer').offset().top;
      var btnHeight = $('#knBoxBtn01').outerHeight();
      var scrollBottom = scrollTop + vHeight;

      // 본문 버튼이 헤더 아래로 사라짐 && 고정 버튼이 footer와 안 겹침
      if (scrollTop + headerHeight > anchorBottom && scrollBottom - btnHeight < footerTop) {
        $('#knBoxBtn01').show();
      } else {
        $('#knBoxBtn01').hide();
      }
    }

    $('#knBoxBtn01').hide();
    updateFixedBtn();
    $(window).scroll(updateFixedBtn);
  }

});
